module.exports = __webpack_public_path__ + "img/Staff System.f25fe03a.svg";